import React, { useState, useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faSquare,
  faTrash,
  faSquareXmark,
  faPlus, // used for "+ Add filter" box
} from "@fortawesome/free-solid-svg-icons";
import Slider from "@mui/material/Slider";
import styled from "styled-components";
import {
  createFilters,
  fetchFilters,
  deleteFilters,
  updateFilters,
} from "../actions/restaurantActions";
import PlusMinusInputsToFilters from "../components/PlusMinusInputsToFilters";
import LoaderComponent from "../components/LoaderComponent";
import { GearSvgIcon, ClockSvgIcon } from "../icons/SvgIcons";
import { Row, Col, Card } from "react-bootstrap";
import { CustomModal } from "./CustomModal";
import TimeRangePicker from "./inputs/TimeRangePicker";
import { ModernButton, CloseIcon, StyledLabel } from "./DefaultImports";
import { ConfirmationModal } from "./ConfirmationModal";

const StyledModalBody = styled.div`
  max-height: none;
  overflow: visible;
  position: relative;
  padding-right: 10px;
`;

const EditableField = styled.input`
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ee754c;
  border-radius: 4px;
  background: white;
  font-size: 14px;
  color: #333;

  &:focus {
    outline: none;
    border-color: #ee561b;
    box-shadow: 0 0 0 2px rgba(238, 117, 76, 0.2);
  }
`;

const FilterItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: nowrap;
`;

const FilterNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  flex-shrink: 0;
`;

const FilterTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const DeleteIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  flex-shrink: 0;
`;

/* aligned dashed add box */
const AddFilterBox = styled.button`
  width: 100%;
  padding: 12px 14px;
  border: 1px dashed #99b0ad;
  border-radius: 8px;
  background: #ffffff;
  color: #99b0ad;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.15s ease;

  &:hover {
    border-color: #ee754c;
    color: #ee754c;
  }
`;

const CustomModali = styled(CustomModal)`
  .modal-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    margin: 0 auto;
    max-width: 500px;
    width: auto;
  }

  .modal-content {
    height: 65vh;
    max-height: 65vh;
    width: 100%;
  }
`;

const FiltersManagement = ({ restaurantId, isOpen, setIsOpen }) => {
  const dispatch = useDispatch();

  const getFilters = useSelector((state) => state.filtersModels);
  const {
    isLoadingCreateFilters,
    createdFilters,
    createdFiltersError,
    startFetchingFilters,
    fetchedFilters,
    fetchedFiltersError,
    isLoadingDeletingFilters,
    deletingFilters,
    deletingFiltersError,
    isLoadingUpdatingFilters,
    updatingFilters,
    updatingFiltersError,
  } = getFilters;

  const [filters, setFilters] = useState([]);
  const [editMode, setEditMode] = useState(true);
  const [toDeleteIds, setToDeleteIds] = useState([]);

  const [newFilters, setNewFilters] = useState([]);
  const [editableFilters, setEditableFilters] = useState([]);
  const [hasOverlap, setHasOverlap] = useState(false);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [filterToDelete, setFilterToDelete] = useState(null);
  const [isNewFilter, setIsNewFilter] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const restaurant_info = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurant_info;

  console.log("inside filters component restaurantId: ", restaurantId);

  const generateIntervalOptions = () => {
    const intervalOptions = [];
    for (let i = 0; i < 24; i++) {
      // Loop hours 0..23
      for (let j = 0; j < 60; j += 30) {
        // Step 30 minutes
        const hour = i.toString().padStart(2, "0");
        const minute = j.toString().padStart(2, "0");
        const time = `${hour}:${minute}`;
        intervalOptions.push(time);
      }
    }
    // Edge case
    intervalOptions.push("24:00");
    return intervalOptions;
  };

  const [intervalOptions, setIntervalOptions] = useState(
    generateIntervalOptions(),
  );

  useEffect(() => {
    if (fetchedFilters) {
      setEditableFilters(fetchedFilters);
    }
  }, [fetchedFilters]);

  useEffect(() => {
    if (restaurants) {
      dispatch(fetchFilters(restaurants.id));
    }
  }, [isOpen, restaurants]);

  const handleAddNewFilter = () => {
    const newFilter = {
      id: Date.now(),
      restaurant_id: restaurantId,
      name: "",
      start_time: "12:00",
      end_time: "20:00",
    };
    setNewFilters([...newFilters, newFilter]);
    setHasUnsavedChanges(true);
  };

  const handleUpdateNewFilter = (tempId, field, value) => {
    const updatedFilters = newFilters.map((filter) => {
      if (filter.id === tempId) {
        return { ...filter, [field]: value };
      }
      return filter;
    });
    setNewFilters(updatedFilters);
    setHasUnsavedChanges(true);
  };

  const handleUpdateEditableFilter = (filter_id, field, value) => {
    const editedFilters = editableFilters.map((filter) => {
      if (filter.id === filter_id) {
        console.log("is it true");
        return { ...filter, [field]: value };
      }
      return filter;
    });
    console.log("editedFilters:  ", editedFilters);
    setEditableFilters(editedFilters);
    setHasUnsavedChanges(true);
  };

  const handleDeleteNewFilter = (tempId) => {
    setNewFilters(newFilters.filter((filter) => filter.id !== tempId));
    setHasUnsavedChanges(true);
  };

  const handleEdit = () => {
    setEditMode(true);
  };

  const addToDeleteIds = (id) => {
    setToDeleteIds([...toDeleteIds, id]);
    const updatedEditableFilters = editableFilters.filter(
      (filter) => filter.id !== id,
    );
    setEditableFilters(updatedEditableFilters);
    setHasUnsavedChanges(true);
  };

  const handleSave = async () => {
    try {
      if (newFilters.length > 0) {
        await dispatch(createFilters(restaurantId, newFilters));
      }

      if (editableFilters.length > 0) {
        await dispatch(updateFilters(restaurantId, editableFilters));
      }

      if (toDeleteIds.length > 0) {
        await dispatch(deleteFilters(restaurantId, toDeleteIds));
      }

      setNewFilters([]);
      setToDeleteIds([]);

      await dispatch(fetchFilters(restaurantId));
      setIsOpen(false);
      setHasUnsavedChanges(false);
    } catch (error) {
      console.error("Erro ao gravar filtros:", error);
    }
  };

  useEffect(() => {
    console.log("toDeleteIds: ", toDeleteIds);
    console.log("editableFilters: ", editableFilters);
    console.log("newFilters: ", newFilters);
  }, [toDeleteIds, editableFilters, newFilters]);

  const resetUnsavedChanges = () => {
    setNewFilters([]);
    setEditableFilters(fetchedFilters || []);
    setToDeleteIds([]);
    setHasUnsavedChanges(false);
  };

  const sortFiltersByStartTime = (filters) => {
    return [...filters].sort((a, b) => {
      const timeA = a.start_time.padStart(5, "0");
      const timeB = b.start_time.padStart(5, "0");
      return timeA.localeCompare(timeB);
    });
  };
  const sortedNewFilters = useMemo(
    () => sortFiltersByStartTime(newFilters),
    [newFilters],
  );
  const sortedEditableFilters = useMemo(
    () => sortFiltersByStartTime(editableFilters),
    [editableFilters],
  );

  const confirmDeleteFilter = () => {
    if (isNewFilter) {
      handleDeleteNewFilter(filterToDelete.id);
    } else {
      addToDeleteIds(filterToDelete.id);
    }

    setShowConfirmation(false);
    setFilterToDelete(null);
  };

  const handleCloseModal = () => {
    if (hasUnsavedChanges) {
      setShowConfirmation(true);
    } else {
      setIsOpen(false);
    }
  };

  return (
    <>
      <LoaderComponent activate={startFetchingFilters} />

      <CustomModali
        centered={false}
        show={isOpen}
        onHide={handleCloseModal}
        title="Filtrar por horários"
        footer={
          !editMode ? (
            <ModernButton onClick={handleEdit}>Editar</ModernButton>
          ) : (
            <>
              <ModernButton color={"#99B0AD"} onClick={handleCloseModal}>
                Cancelar
              </ModernButton>
              <ModernButton color={"#EE754C"} onClick={handleSave}>
                Guardar
              </ModernButton>
            </>
          )
        }
      >
        <StyledModalBody>
          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
            <div style={{ flex: 1 }}>
              <StyledLabel style={{ marginTop: "0px" }}>Horário</StyledLabel>
            </div>
            <div style={{ width: "150px" }}>
              <StyledLabel style={{ marginTop: "0px" }}>
                Nome (opcional)
              </StyledLabel>
            </div>
            <div style={{ width: "40px" }}></div>
          </div>

          {editMode &&
            sortedNewFilters.map((filter) => (
              <FilterItemRow key={filter.id}>
                <FilterTimeContainer>
                  <TimeRangePicker
                    startTime={filter.start_time}
                    endTime={filter.end_time}
                    onChange={(value) => {
                      console.log(
                        "Valor retornado pelo TimeRangePicker:",
                        value,
                      );
                      if (Array.isArray(value)) {
                        const [start, end] = value;
                        setNewFilters((prev) =>
                          prev.map((f) =>
                            f.id === filter.id
                              ? { ...f, start_time: start, end_time: end }
                              : f,
                          ),
                        );
                        setHasUnsavedChanges(true);
                      }
                    }}
                  />
                </FilterTimeContainer>
                <FilterNameContainer>
                  <EditableField
                    value={filter.name === "" ? "" : filter.name}
                    onChange={(e) =>
                      handleUpdateNewFilter(filter.id, "name", e.target.value)
                    }
                    placeholder="Ex: Manhã"
                  />
                </FilterNameContainer>
                <DeleteIconContainer>
                  <CloseIcon
                    style={{ color: "#99B0AD" }}
                    onClick={() => handleDeleteNewFilter(filter.id)}
                  />
                </DeleteIconContainer>
              </FilterItemRow>
            ))}

          {editableFilters &&
            sortedEditableFilters.map((filter) => (
              <FilterItemRow key={filter.id}>
                <FilterTimeContainer>
                  <TimeRangePicker
                    startTime={filter.start_time}
                    endTime={filter.end_time}
                    onChange={(value) => {
                      console.log(
                        "🟦 Filtro existente - valor recebido do TimeRangePicker:",
                        value,
                      );

                      if (Array.isArray(value)) {
                        const formatTime = (date) => {
                          if (typeof date === "string") return date;
                          if (date instanceof Date) {
                            const hours = String(date.getHours()).padStart(
                              2,
                              "0",
                            );
                            const minutes = String(date.getMinutes()).padStart(
                              2,
                              "0",
                            );
                            return `${hours}:${minutes}`;
                          }
                          return "";
                        };

                        const [start, end] = value.map(formatTime);

                        setEditableFilters((prev) =>
                          prev.map((f) =>
                            f.id === filter.id
                              ? { ...f, start_time: start, end_time: end }
                              : f,
                          ),
                        );
                        setHasUnsavedChanges(true);
                      }
                    }}
                  />
                </FilterTimeContainer>
                <FilterNameContainer>
                  <EditableField
                    disabled={!editMode}
                    value={filter.name}
                    onChange={(e) =>
                      handleUpdateEditableFilter(
                        filter.id,
                        "name",
                        e.target.value,
                      )
                    }
                  />
                </FilterNameContainer>
                <DeleteIconContainer>
                  <CloseIcon
                    style={{ color: "#99B0AD" }}
                    onClick={() => addToDeleteIds(filter.id)}
                  />
                </DeleteIconContainer>
              </FilterItemRow>
            ))}

          <FilterItemRow>
            <div style={{ flex: 1 }}>
              <AddFilterBox onClick={handleAddNewFilter}>
                <FontAwesomeIcon icon={faPlus} />
                Adicionar filtro
              </AddFilterBox>
            </div>
            <div style={{ width: 36 }} />
          </FilterItemRow>
        </StyledModalBody>
      </CustomModali>

      {showConfirmation && (
        <ConfirmationModal
          show={showConfirmation}
          onHide={() => setShowConfirmation(false)}
          onConfirm={() => {
            setShowConfirmation(false);
            setIsOpen(false);
            resetUnsavedChanges();
          }}
          centered={false}
          topSpacing={"150px auto"}
          title="Sair sem salvar?"
          body="Tem certeza que deseja sair sem guardar as alterações?"
          confirmLabel="Sim, sair"
          cancelLabel="Cancelar"
          confirmColor="#ee754c"
          cancelColor="#6c757d"
        />
      )}
    </>
  );
};

export default FiltersManagement;
